// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "airplane__amenities-3oJpO";
var _4 = "airplane__info-1WpRG";
var _5 = "airplane__info_wrapper-2rcSN";
var _6 = "airplane__name-13XQj";
var _7 = "amenities__item-D57uO";
var _8 = "details-15VCR";
var _9 = "seatsDetails-3qCh8";
var _a = "airplane-2VeQQ";
var _b = "segment-14DaH";
export { _1 as "__esModule", _2 as "mobile", _3 as "airplane__amenities", _4 as "airplane__info", _5 as "airplane__info_wrapper", _6 as "airplane__name", _7 as "amenities__item", _8 as "details", _9 as "seatsDetails", _a as "airplane", _b as "segment" }
export default { "__esModule": _1, "mobile": _2, "airplane__amenities": _3, "airplane__info": _4, "airplane__info_wrapper": _5, "airplane__name": _6, "amenities__item": _7, "details": _8, "seatsDetails": _9, "airplane": _a, "segment": _b }
